import { render, staticRenderFns } from "./sala-de-prensa.vue?vue&type=template&id=1141c3f7&scoped=true"
import script from "./sala-de-prensa.vue?vue&type=script&lang=js"
export * from "./sala-de-prensa.vue?vue&type=script&lang=js"
import style0 from "./sala-de-prensa.vue?vue&type=style&index=0&id=1141c3f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1141c3f7",
  null
  
)

export default component.exports